import { asArray } from 'ol/color';
import { getCenter } from 'ol/extent';
import { transformExtent } from 'ol/proj';

export const ciColors = {
  blue: 'rgb(0, 115, 181)',
  yellow: 'rgb(255,213,0)',
  grey: '#ccc',
  darkGrey: '#111',
  Buero: 'rgb(0,120,170)',
  Gewerbe: 'rgb(190,0,0)',
  Grundstueck: 'rgb(60,160,0)'
};

// 180620000 = Grundstück
// 180620001 = Bürofläche
// 180620002 = Gewerbeobjekt
export const objektFarben = {
  180620000: ciColors['Grundstueck'],
  180620001: ciColors['Buero'],
  180620002: ciColors['Gewerbe']
};

export const objektNameKey = {
  180620000: 'Grundstück',
  180620001: 'Büro',
  180620002: 'Gewerbeobjekt'
};

export const statusFarben = {
  100000000: 'orange darken-1',
  180620000: 'grey',
  180620001: 'grey',
  180620002: 'light-green darken-4',
  180620003: 'light-green darken-3',
  180620004: 'blue-grey',
  200000000: 'amber darken-4'
};

export const statusItems = [
  { value: 180620000, text: 'Nicht anzeigen' },
  { value: 180620001, text: 'Entwurf' },
  { value: 180620002, text: 'Anzeigen mit Login' },
  { value: 180620003, text: 'Anzeigen ohne Login' },
  { value: 180620004, text: 'Intern' },
  { value: 200000000, text: 'In Begutachtung' }
];

// https://css-tricks.com/converting-color-spaces-in-javascript/
export function getHexColor(color) {
  if (color[0] === '#') {
    return color;
  } else {
    // Choose correct separator
    const sep = color.indexOf(',') > -1 ? ',' : ' ';
    // Turn "rgb(r,g,b)" into [r,g,b]
    color = color.substr(4).split(')')[0].split(sep);

    let r = (+color[0]).toString(16),
      g = (+color[1]).toString(16),
      b = (+color[2]).toString(16);

    if (r.length == 1) {
      r = '0' + r;
    }
    if (g.length == 1) {
      g = '0' + g;
    }
    if (b.length == 1) {
      b = '0' + b;
    }

    return '#' + r + g + b;
  }
}

export const fillColors = Object.assign({}, objektFarben);
for (const key in fillColors) {
  const color = asArray(fillColors[key]);
  color[3] = 0.2;
  fillColors[key] = color;
}

// 180620000 = Grundstück
// 180620001 = Bürofläche
// 180620002 = Gewerbeobjekt
export const objektIcons = {
  180620002: 'gewerbe.png',
  180620001: 'buero.png',
  180620000: 'grundstueck.png'
};

/**
 * resolution for:
 * switch between Basemap / Orthofoto
 * display objekt bounderies
 */
export const switchResolution = 2.42;

// extent taken from noe borders
export const wgsNoeExtent = [14.45423578, 47.42218427, 17.06882327, 49.02045613000004];
export const noeExtent = transformExtent(wgsNoeExtent, 'EPSG:4326', 'EPSG:3857');
export const CENTER = getCenter(wgsNoeExtent);

// Text for special Object (Advertising)
export const advertHTML = {
  de: {
    sidebar: 'Hinweis',
    title: 'Nicht die passende Immobilie dabei?',
    content:
      'Eine Alternative zum Kauf oder der Einmietung könnte auch die Übernahme eines bestehenden Unternehmens sein. Finden Sie gemeinsam mit uns Unternehmen, die zum Verkauf stehen oder einen Nachfolger suchen. Wir unterstützen Sie dabei - Informieren Sie sich bei uns!',
    button: 'Auf diesem Browser nicht länger anzeigen',
    confirmhead: 'Auf diesem Browser nicht mehr anzeigen?',
    confirmtext: 'Soll dieser Hinweis auf dem aktuell verwendeten Browser zukünftig ausgeblendet werden?'
  },
  en: {
    sidebar: 'Notice',
    title: 'Not the right property for you?',
    content:
      'An alternative to buying or renting could be to take over an existing company. Work with us to find companies that are for sale or looking for a successor. We will support you! Find out more - Company succession with ecoplus',
    button: 'Do not show again on this browser',
    confirmhead: 'No longer display on this browser?',
    confirmtext: 'Should this notice be hidden on the browser currently in use in future?'
  }
};

/**
 * default ecoplus contact to display in the PDF and the "Kontakt Ecoplus" page,
 * if no other ecoplus-contact is defined in CRM
 */
export const defaultContact = {
  name: 'ecoplus. Niederösterreichs Wirtschaftsagentur GmbH',
  anschrift: 'Niederösterreichring 2, Haus A',
  plz: '3100',
  ort: 'St. Pölten, Österreich',
  telefon: '+43 2742 9000-19731',
  email: 'standort.service@ecoplus.at',
  website: 'www.ecoplus.at/investorenservice'
};
